(ns common.permissions.pipeline-permissions
  (:require [common.permissions.field-permissions :as field-permissions]
            [common.util :as cu]
            [common.roles :as roles]))

(def sales-pipeline-configuration-entity-types
  [:entity.type/investor
   :entity.type/person
   :entity.type/company])

(defn pipeline-configuration-entity-types
  [pipeline]
  (if (= (:pipeline/entity-type pipeline) :entity.type/sales-opportunity)
    sales-pipeline-configuration-entity-types
    (:pipeline/target-asset-types pipeline)))

(defn access-to-pipelines
  [all-pipelines account-teams biggest-role]
  (let [team-ids (->> account-teams
                      (into
                       #{}
                       (map (fn [at]
                              (or (:db/id at) at)))))]
    (if (roles/admin? biggest-role)
      all-pipelines
      (->> all-pipelines
           (filterv (fn [pipeline]
                      (->> pipeline
                           :pipeline/teams
                           (cu/find-first
                            (fn [t]
                              (contains? team-ids
                                         (or (:db/id t) t)))))))))))

(defn resolve-pipelines-config
  [{:keys [entity-type global-config tenant-field-configurations pipeline-settings
           account-role account-teams logger] :as _args}]
  (->> global-config
       (reduce-kv
        (fn [m attr-key account-global-access-to-attribute]
          (let [;;if currency-symbol, get the config
                ;; based on the currency attribute:
                config-attr (if (cu/currency-symbol? attr-key)
                              (cu/currency-symbol->currency attr-key)
                              attr-key)
                pipeline-attribute-config (-> pipeline-settings
                                              (get entity-type)
                                              (get config-attr))
                global-attribute-config (-> tenant-field-configurations
                                            (get entity-type)
                                            (get config-attr))
                in-use-config (or (:field-settings/in-use-config pipeline-attribute-config)
                                  (some-> global-attribute-config
                                          :field-settings/in-use-config))
                user-access
                (if-not (contains? field-permissions/POSITIVE-IN-USE-VALUES in-use-config)
                  :none
                  (case account-role
                    :role/guest-buy-side
                    (:field-settings/buy-side-guest pipeline-attribute-config)

                    :role/guest-sell-side
                    (:field-settings/sell-side-guest pipeline-attribute-config)

                    :role/admin
                    (if (contains? field-permissions/NEGATIVE-IN-USE-VALUES in-use-config)
                      :none
                      ;; always >= max-team-access:
                      account-global-access-to-attribute)

                    (cond
                      (contains? field-permissions/NEGATIVE-IN-USE-VALUES in-use-config)
                      :none
                      (contains? field-permissions/POSITIVE-IN-USE-VALUES in-use-config)
                      (let [team-cfgs (->> account-teams
                                           (mapv field-permissions/team-configuration-keyword)
                                           (mapv (fn [team-key]
                                                   (let [pipeline-cfg (get pipeline-attribute-config
                                                                           team-key)
                                                         global-cfg (get global-attribute-config
                                                                         team-key)]
                                                     ;; if pipeline-cfg is not set for the team,
                                                     ;; fallback to global team-specific setting
                                                     (or pipeline-cfg
                                                         global-cfg)))))
                            pipeline-field-setting
                            (if (empty? team-cfgs)
                              nil
                              (->> team-cfgs
                                   (apply max-key
                                          (fn [p]
                                            (if (nil? p)
                                              -1
                                              (field-permissions/permission-order p logger))))))]
                        pipeline-field-setting))))]

            (assoc! m attr-key
                    (or user-access account-global-access-to-attribute))))
        (transient {}))
       persistent!))

(defn account-pipeline-access-config [{:keys [tenant-field-configurations
                                              account-field-permissions
                                              pipeline
                                              pipeline-settings
                                              account-role
                                              account-teams
                                              logger]}]
  (let [pipeline-entity-type (:pipeline/entity-type pipeline)
        target-types (set (pipeline-configuration-entity-types pipeline))
        permissions (select-keys account-field-permissions
                                 (conj target-types pipeline-entity-type))]
    (->> permissions
         (reduce-kv
          (fn [m entity-type global-config]
            (let [cfg (resolve-pipelines-config
                       {:tenant-field-configurations tenant-field-configurations
                        :global-config global-config
                        :entity-type entity-type
                        :pipeline-settings pipeline-settings
                        :pipeline pipeline
                        :account-role account-role
                        :account-teams account-teams
                        :logger logger})]
              (assoc m entity-type cfg)))
          {}))))

(defn resolve-account-pipeline-field-permissions
  [tenant-field-configurations account-field-permissions account-pipelines account-teams
   account-role edn-reader & [logger]]
  (->> account-pipelines
       (into
        {}
        (comp
         (remove :common/disabled?)
         (map (fn [pipeline]
                (let [pipeline-settings (let [settings (:pipeline/settings pipeline)]
                                          (cond (map? settings) settings
                                                (string? settings) (edn-reader settings)
                                                :else nil))
                      account-pipeline-access-config (account-pipeline-access-config
                                                      {:account-field-permissions   account-field-permissions
                                                       :tenant-field-configurations tenant-field-configurations
                                                       :pipeline                    pipeline
                                                       :pipeline-settings           pipeline-settings
                                                       :account-role                account-role
                                                       :account-teams               account-teams
                                                       :logger                      logger})]
                  [(:db/id pipeline) account-pipeline-access-config])))))))
